/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable object-shorthand */
import RenderHtml from 'react-native-render-html';
import { View } from '../../components/Themed';
import { RootStackScreenProps } from '../../navigation/navigationTypes';
// Image assets
import SnapCalorieSitePage from '../../components/SnapCalorieSitePage';
import Terms from './terms_html';

const source = {
  html: Terms,
};
export default function TermsScreen({ navigation }: RootStackScreenProps<'Terms'>) {
  return (
    <SnapCalorieSitePage
      headerLinks={{
        Home: () => {
          navigation.navigate('Home');
        },
      }}
    >
      <View style={{ alignSelf: 'center', paddingLeft: 40, maxWidth: 800 }}>
        <RenderHtml contentWidth={800} source={source} />
      </View>
    </SnapCalorieSitePage>
  );
}
